<div class="flex-vertical gap-16 width-100pc">
  <div>
    {{ totalCount }} @if (totalCount > 1) {
    <span>utilisateurs</span>
    }@if (totalCount < 2) {
    <span>utilisateur</span>
  }
</div>
<div class="width-100pc">
  <oui-table>
    <table mat-table [dataSource]="dataSource" matSort #usersSort="matSort">
      <ng-container matColumnDef="nom">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let element">{{ element?.displayName }}</td>
      </ng-container>

      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef>Rôle</th>
        <td mat-cell *matCellDef="let element">{{ element?.isAdmin ? 'Admin' : 'Gestionnaire' }}</td>
      </ng-container>

      <ng-container matColumnDef="group">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Groupe par défaut</th>
        <td mat-cell *matCellDef="let element">
          @if (element?.groupeGestionnaire === 'PSI') {
            <b class="color-stellium-financement-primary">PSI</b>
          }
          @if (element?.groupeGestionnaire === 'SVP') {
            <b class="color-stellium-immo-primary">SVP</b>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="toggleExtendedAccess">
        <th mat-header-cell *matHeaderCellDef>Activer extension groupe</th>
        <td mat-cell *matCellDef="let element">
          <oui-slide-toggle
            label=""
            (checkedChange)="onUserRightsToggle(element)"
            [checked]="element?.withGroupeAccessExtended ?? false"
            (click)="$event.stopPropagation()">
          </oui-slide-toggle>
          <b
              [ngClass]="{
                'color-stellium-immo-primary':
                  element?.withGroupeAccessExtended && element?.groupeGestionnaire !== 'SVP',
                'color-stellium-financement-primary':
                  element?.withGroupeAccessExtended && element?.groupeGestionnaire !== 'PSI',
                'color-on-surface-disabled': !element?.withGroupeAccessExtended,
              }"
            >{{ element?.groupeGestionnaire === 'SVP' ? 'PSI' : 'SVP' }}</b
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="deactivateButton">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <oui-button type="text" (click)="onDeactivateGestionnaire(element)">Supprimer</oui-button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        @if (!isLoading) {
          <tr mat-row [class.interactive]="true" *matRowDef="let row; columns: displayedColumns"></tr>
        }
      </table>
      @if (isLoading) {
        <oui-loading class="flex-vertical flex-center padding-vertical-16"></oui-loading>
      }
      <oui-paginator
        [pageSizeOptions]="pageSizeOptions"
        [length]="totalCount"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize">
      </oui-paginator>
    </oui-table>
  </div>
</div>
